import { ButtonThemePalette } from '../Button.types';

export const outlinedWithoutBackground = ({
  button,
}: ButtonThemePalette): string => `
  background: none;
  border: solid 1px ${button.border.outline.base};
  color: ${button.text.outline.base};

  &:hover,
  &:focus {
    border: solid 1px ${button.border.outline.hover};
  }
`;
